export const HIGHLIGHTED_CARD_ZINDEX = 100;
export const CARD_DIVIDER_ZINDEX = 20;
export const CARD_ZINDEX = 10;
export const CARD_SIDES_PADDING = '20px';
//# sourceMappingURL=consts.js.map